/* @flow */

import { type FuncionamentosPorDiaSemana, type Funcionamento } from './types';
import { DIAS_SEMANA, ENUM_NOMES_DIAS_SEMANA } from './constants';

const checkbox = ({ id, horaFim, horaInicio }: Funcionamento) => `
<label class="m-checkbox">
    <input type="checkbox" name="funcionamentosId[]" value="${id}">
    ${horaInicio} - ${horaFim}
    <span></span>
</label>
`;

const formGroup = (nome: string, funcionamentos: Funcionamento[]) => `
<div class="form-group m-form__group row">
    <label class="col-form-label col-lg-3 col-sm-12">
        ${nome}:
    </label>
    <div class="col-lg-6 col-md-9 col-sm-12">
        <div class="m-checkbox-inline">
            ${funcionamentos.map(checkbox).join('')}
        </div>
    </div>
</div>
`;

const viewFormularioFuncionamento = (horarios: FuncionamentosPorDiaSemana) => DIAS_SEMANA
    .filter(diaSemanasId => horarios[diaSemanasId].length > 0)
    .map(diaSemanasId => formGroup(ENUM_NOMES_DIAS_SEMANA[diaSemanasId], horarios[diaSemanasId]))
    .join('');

export default viewFormularioFuncionamento;
